export const LOADING_LIST = 'LOADING_CONTRACT_LIST_FROM_BACKEND';
export const LOAD_LIST = 'LOAD_CONTRACT_LIST_FROM_BACKEND';
export const UPDATE_PROPS = 'UPDATE_PROPS_IN_CONTRACT_LISTING';
export const UPDATE_FOLDER_NAME = '[contract-list]UPDATE_FOLDER_NAME';
export const UPDATE_PARAMS = '[contract-list]UPDATE_SEARCH_PARAMS';
export const RESET_PARAMS = '[contract-list]RESET_SEARCH_PARAMS';
export const SHOW_FREE_CONTRACT_DIALOG = 'SHOW_FREE_CONTRACT_DIALOG';
export const SELECT_ONE_CONTRACT = 'SELECT_ONE_CONTRACT_CONTRACT_LIST';
export const MASS_ASSIGN_FOLDER = 'MASS_ASSIGN_FOLDER_CONTRACT_LIST';
export const DELETE_FOLDER = 'DELETE_FOLDER_CONTRACT_LIST';
export const CREATE_FOLDER = 'CREATE_FOLDER_CONTRACT_LIST';
export const STATE_CHANGE = 'STATE_CHANGE_CONTRACT_LIST';
export const MARK_AS_RECEIVED = 'MARK_AS_RECEIVED_CONTRACT_LIST';
export const SELECT_CURRENT_ALL = 'SELECT_CURRENT_ALL_CONTRACT_LIST';
export const MASS_DELETE_RESTORE = 'MASS_DELETE_RESTORE_CONTRACT_LIST';
export const MASS_ARCHIVE_OR_RESTORE = '[contract-list] MASS_ARCHIVE_OR_RESTORE';
export const DOWNLOADING_PDF_ZIP = 'DOWNLOADING_PDF_ZIP_CONTRACT_LIST';
export const PDF_ZIP_DOWNLOADED = 'PDF_ZIP_DOWNLOADED_CONTRACT_LIST';
export const TOGGLE_BULK_RESEND_DIALOG = 'TOGGLE_BULK_RESEND_DIALOG_CONTRACT_LIST';
export const POPULATE_BULK_RESEND = 'POPULATE_BULK_RESEND_DIALOG_CONTRACT_LIST';
export const BULK_SENDING = 'BULK_SENDING_CONTRACTS_IN_CONTRACT_LIST';
export const BULK_SEND_FINISHED = 'BULK_SEND_FINISHED_IN_CONTRACT_LIST';
export const UPDATE_BULK_RESEND_PROPS = 'UPDATE_BULK_RESEND_PROPS_IN_CONTRACT_LIST';
export const GET_CONTRACT_EMAIL = '[contract-list]GET_CONTRACT_FORWARDING_EMAIL';
export const LOAD_CONTRACT_LIST = '[contract-list]LOAD_CONTRACT_LIST';
export const GET_MORE_CONTRACT_INFO = '[contract-list] GET_MORE_CONTRACT_INFO';



// WEBPACK FOOTER //
// ./src/app/stores/contracting/contract-list/contract-list-constants.js